import Group from "~/components/institutional/FAQ/Group";
import Questions from "~/components/institutional/FAQ/Questions";
import Search from "~/components/institutional/FAQ/Search";
import SearchResult from "~/components/institutional/FAQ/SearchResult";
import Slider from "~/components/ui/Slider";
import SliderJS from "~/components/ui/SliderJS";
import type { Group as IGroup } from "~/components/institutional/FAQ/useFAQ";
import { isSchedulingActive } from "~/sdk/contentScheduling";
import { type FnContext as FnContext, type SectionProps as SectionProps } from "~/types/deco";
export interface Props {
    /**
     * @title Título
     */
    title?: string;
    /**
     * @title Grupos
     */
    groups: IGroup[];
}
export default function FAQ({ title = 'Selecione uma opção', groups, isMobileDevice, }: SectionProps<typeof loader>) {
    if (!groups?.length)
        return null;
    return (<div className='w-full max-w-[1810px] mx-auto my-3'>
            <div className='p-5 bg-[#f9f9f9]'>
                <h3 className='text-salmon text-xl text-center font-bold'>{title}</h3>

                {isMobileDevice
            ? (<div id='faq' className='my-5'>
                            <Slider className='carousel w-full gap-3'>
                                {groups.map((group, index) => (<Slider.Item className='carousel-item w-2/5 shrink-0' index={index}>
                                        <Group {...group}/>
                                    </Slider.Item>))}
                            </Slider>

                            <div className='mt-3 flex flex-wrap justify-center gap-1'>
                                {groups.map((_, index) => Boolean((index + 1) % 2) && (<Slider.Dot className='w-6 h-2 rounded-full opacity-40 bg-[#d9d9d9] transition-colors duration-300 disabled:opacity-100 disabled:bg-salmon' index={index}/>))}
                            </div>

                            <SliderJS rootId='faq'/>
                        </div>)
            : (<ul className='my-5 flex flex-wrap justify-center gap-4'>
                            {groups.map((group) => <Group {...group}/>)}
                        </ul>)}

                <div className='max-w-[1134px] pt-5 mx-auto border-t border-[#e3e3e3] flex flex-col gap-8 lg:flex-row lg:justify-between lg:items-center'>
                    <span className='text-lg font-semibold shrink-0'>
                        Se não encontrar o que deseja, digite ao lado sua pergunta:
                    </span>

                    <Search groups={groups}/>
                </div>
            </div>

            <div id='questions'>
                <Questions />
                <SearchResult />
            </div>
        </div>);
}
export const loader = (props: Props, _: Request, ctx: FnContext) => {
    const isMobileDevice = ctx.device !== 'desktop';
    const groups = props.groups
        .filter(({ questions }) => questions.length > 0)
        .map((group) => ({
        ...group,
        questions: group.questions
            .filter(({ scheduling }) => {
            return isSchedulingActive(scheduling);
        }),
    }));
    return { ...props, groups, isMobileDevice };
};
